
const ArrowDownIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="18" height="18" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
<path d="M45 3967 c-43 -43 -52 -79 -34 -129 20 -55 2458 -2695 2508 -2715 79 -33 2 -110 1343 1342 894 968 1237 1345 1247 1373 18 50 9 86 -34 129 -28 28 -40 33 -78 33 -25 0 -53 -3 -61 -6 -9 -4 -546 -580 -1193 -1280 -647 -701 -1179 -1274 -1183 -1274 -4 0 -536 573 -1183 1274 -647 700 -1184 1276 -1193 1280 -8 3 -36 6 -61 6 -38 0 -50 -5 -78 -33z"/>
</g>
</svg>
  )
}

export default ArrowDownIcon